<script lang="ts">
  import { inview } from 'svelte-inview';
  import PaginatedLoader from '$lib/components/common/loaders/PaginatedLoader.svelte';
  import type { GalleryFiltersSchema, SortOption } from '$src/utils/api/feed.util';
  import { range } from 'lodash-es';
  import SkeletonGalleryCard from '$lib/components/common/skeletons/SkeletonGalleryCard.svelte';
  import  scrollToLastItemOnLoad  from '$lib/actions/scrollToLastItemOnLoad';
  import { writable } from 'svelte/store';

  import type { FChallenge } from 'garden-common';
  import ChallengesCard from '../challenges/ChallengesCard.svelte';
  import { findChallenges } from '$src/utils/api/challenges.util';

  export let sort: SortOption;
  export let filters: GalleryFiltersSchema;

  let challenges: FChallenge[] = [];

  let fetchPage: () => Promise<void>;

  let failed = false;
  let exhausted = false;
  let loading = false;

  let paginatedLoader: PaginatedLoader<FChallenge>;

  function refresh() {
    if (!paginatedLoader) {
      return;
    }

    paginatedLoader.reset();
    paginatedLoader.fetchPage();
  }

  $: sort, filters, refresh();

  const challengesStore = writable<typeof challenges>();

  $: $challengesStore = challenges;

  const lastItemContainer = writable<HTMLElement>();
</script>

<PaginatedLoader
  bind:this={paginatedLoader}
  bind:items={challenges}
  bind:failed
  bind:exhausted
  bind:fetchPage
  bind:isLoading={loading}
  limit={6}
  fetchFunction={findChallenges}
  loadPageOnMount={false}
  getFetchFunctionOpts={({ page, limit }) => ({
    page,
    limit,
    sort,
    filters
  })}
/>

<div
  class="pt-4 overflow-auto"
  use:scrollToLastItemOnLoad={{ arrToWatch: challengesStore, lastItemContainer }}
>
  <div class="lg:px-4 px-2 py-24 lg:py-4 rounded-2xl">
    <div class="flex gap-y-4 flex-col">
      <div class="w-full">
        <div class="w-full font-black flex flex-row justify-between uppercase">
          <span class="uppercase text-xl text-garden-grey-700 font-black">Explore Challenges</span>
        </div>
      </div>
      <div class="grid lg:grid-cols-3 gap-4">
        {#each challenges as challenge}
            <div bind:this={$lastItemContainer}>
              <ChallengesCard {challenge} variant="vertical" />
            </div>
          
        {/each}
      </div>

      {#key challenges}
        {#if !exhausted}
          <div use:inview on:inview_enter={fetchPage} class="grid lg:grid-cols-3 gap-4">
            {#each range(9) as _}
              <SkeletonGalleryCard /> 
              <!--Same format for challenges so we should be good-->
            {/each}
          </div>
        {/if}
      {/key}

      <div class="font-bold text-center w-full text-gray-400 mt-8 h-80">
        {#if failed}
          Load failed.
        {:else if exhausted}
          No more challenges to show.
        {:else}
          Loading...
        {/if}
      </div>
    </div>
  </div>
</div>
